<script>
import Testimonial from "../Testimonial.vue";

export default {
  components: { Testimonial },
  name: "FormulatingFoundationsLeft",
  data: function() {
    return {
      testimonials: {
        kristin: {
          photo: "powerdrops/testimonial-kristin.png",
          name: "Kristín Sjofn",
          title: "Aromatherapist and educator, Aromatherapyskólinn.",
          quote: `Woww!!! It is like coming out of the "dark ages"... Thanks for the class. It is not too much chemistry for me because it is so colorful and fun.`
        },
        loccitane: {
          photo: "powerdrops/testimonial-loccitane.png",
          name: "Natalija Mesojedec",
          title: "Retail Manager, L'OCCITANE Slovenia.",
          quote: `<p>In  the company Stillmark d.o.o., the exclusive representative for the brand L’OCCITANE en Provence for Slovenia, in 2014, we decided to  cooperate with Mrs. Melani Kovač.
As essential oils and hydrolats are one of the key active ingredients  in L’OCCITANE products, we organized a lecture on the topic Introduction to aromatherapy and the use of essential oils and hydrolats in cosmetics under the guidance of Melani.
<p>The purpose of the lecture was to consolidate and deepen the expertise of our beauty consultants. Melani overwhelmed us with her knowledge and sincere love for these  precious essences of nature. Her lecture was professional, dynamic,  interactive, and practical. Everyone attending the workshop remains  extremely satisfied with its implementation.
<p>We effectively use the newly acquired knowledge in consulting collections and products based on  essential oils and floral waters. We successfully pass on the  enthusiasm for these natural ingredients with miraculous power to our  customers.`
        },
      }
    };
  }
};
</script>
<template>
  <div id="pd-left-container">
    <Testimonial :testimonial="testimonials.kristin" />
    <div id="special-offer">
      <h4 style="font-weight: 700; margin-bottom: 2rem;">
        Here's what you'll get:
      </h4>
      <img src="@/assets/aromaempress/platforms.png" width="100%">
    </div>
    <ul id="ul1">
        <li class="list-red-icon">
          <span><strong>FORMULATING FOUNDATIONS online course:</strong> Setting fresh standards for blending with essential oils in one day class. 
          Massive amount of professional, straightforward formulating strategies in minutes, ready to implement in your practice</span>
        </li>
        <li class="list-red-icon">
          <span><strong>Certificate of Attendance:</strong> Attend the course and get your certificate</span>
        </li>
        <li class="list-red-icon">
          <span><strong>Lifetime access:</strong> Enroll now and get lifetime access to the course</span>
        </li>
        <li class="list-red-icon">
          <span><strong>BONUSES you'll get:</strong></span>
        </li>
        <ul>
          <li>
            Basic chemistry PDF
          </li>
          <li>
            VIP Community
          </li>
          <li>
            Extra lessons answering your questions
          </li>
        </ul>
    </ul>
    <b-card no-body class="overflow-hidden" style="font-size: 0.8em; border: none; margin-top: 3rem">
      <b-row no-gutters>
        <b-col md="3">
          <b-card-img :src="require('@/assets/aromaempress/Just-30-Days-Guarantee.jpg')"/>
        </b-col>
        <b-col md="9">
          <b-card-body title="30-Day Money-Back Guarantee">
            <b-card-text>
            Try it <strong>100% RISK-FREE with our 30-day-money-back-guarantee</strong>. If for some reason
            you aren't on your way to real success in the first 30 days, email us and we will take care of your refund!
            This means you get 30 days of test driving, on us!
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
    <div class="testimonials">
    <Testimonial :testimonial="testimonials.loccitane" />
    </div>
  </div>
</template>

<style lang="scss">
@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

* {
  font-family: $font-family;
}

#pd-left-container {
  font-size: 1.3rem;
  flex-basis: 100%;
  margin-top: -65px;
  color: #293847;
}

#special-offer {
  margin: 2rem 1rem;
  h2 {
    font-size: 2em;
    text-transform: uppercase;
    font-weight: $font-bold;
  }
  p {
    font-size: 1.35em;
    text-align: center;
    padding: 1em;
    background-color: #ffea01;
  }
  span {
    font-size: 0.9em;
  }
}

.bonus {
   margin-left: 10px;
    display: inline;
}

#program-content {
  line-height: 1.77em;
  h4 {
    font-size: 1em;
    font-weight: 600;
    margin-bottom: 1em;
  }
  ul {
    margin-left: 1em;
    padding: 0;    
  }
}
.list-red-icon {
  background: url(../../../assets/aromaempress/red-bullet.png) no-repeat left top;
  padding: 5px 40px 0px 40px;
  margin-left: -1em;
  margin-bottom: 20px;
  text-align: justify;
  list-style: none;
}
</style>
